<template>
  <div>
    <HighChartsTcpaHistory
      v-if="tcpaHistory.length > 0"
      :data="tcpaHistory"
      :moment-timezone-id="accountTranslatedTimeZoneId"
    />
    <TcpaHistoryTable
      :tcpa-history-data="tcpaHistory"
      :loading-status="actionStatus.status"
      :moment-timezone-id="accountTranslatedTimeZoneId"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import HighChartsTcpaHistory from './HighChartsTcpaHistory';
import TcpaHistoryTable from './TcpaHistoryTable.vue';
import { getStatus } from '@/store/helpers';

export default {
  components: { HighChartsTcpaHistory, TcpaHistoryTable },
  props: {
    dayRange: {
      type: Number,
      default() {
        return 30;
      },
    },
  },
  computed: {
    ...mapState('tcpaShield', ['tcpaHistory']),
    ...mapState('tcpaShield', {
      actionStatus: (state) => getStatus(state, 'getTcpaHistory')
    }),
    ...mapGetters(['accountTranslatedTimeZoneId'])
  },
  created() {
    this.getTcpaHistory();
  },
  methods: {
    ...mapActions('tcpaShield', ['getTcpaHistory']),
  },
};
</script>

<style>
</style>